import {
  Accordion,
  AccordionItem,
  AccordionItemHeading as KitAccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import styled from 'styled-components';
import { border, fontWeight, spacing, breakpoints } from '../common/theme/constants';
import colors from '../common/theme/colors';

// KitAccordion uses react-accessible-accordion: https://github.com/springload/react-accessible-accordion

export interface KitAccordionItemButtonProps {
  arrowAdjacentToText?: boolean;
  disabled?: boolean;
}

const KitAccordion = styled(Accordion)`
  border: 1px solid ${({ theme }) => theme.accordion.border};
  border-radius: ${border.radius}px;
  border-bottom: none;
`;

const KitAccordionItem = styled(AccordionItem)`
  border-bottom: 1px solid ${({ theme }) => theme.accordion.border};
  padding: 0;
`;

const KitAccordionItemButton = styled(AccordionItemButton)<KitAccordionItemButtonProps>`
  padding: ${spacing.absolute.s}px;
  @media all and (min-width: ${breakpoints.xs}px) {
    padding: ${spacing.absolute.m}px;
  }
  font-weight: ${fontWeight.bold};
  color: ${({ theme }) => theme.accordion.text};
  cursor: pointer;
  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
  `};

  // styles for arrow
  &:after {
    margin: ${spacing.absolute.xs}px ${spacing.absolute.sm}px 0 ${spacing.absolute.s}px;
    position: absolute;
    ${({ arrowAdjacentToText }) =>
      !arrowAdjacentToText &&
      `
      right: ${spacing.absolute.xl}px;
    `}
    content: '';
    height: 10px;
    width: 10px;
    border-bottom: 2px solid
      ${({ theme, disabled }) => (disabled ? colors.transparent : theme.accordion.caret)};
    border-right: 2px solid
      ${({ theme, disabled }) => (disabled ? colors.transparent : theme.accordion.caret)};
    transform: rotate(45deg);
  }

  [dir='rtl'] &:after {
    right: unset;
    left: ${spacing.absolute.xl}px;
  }

  &[aria-expanded='true']::after,
  &[aria-selected='true']::after {
    transform: rotate(-135deg);
    margin-top: ${spacing.absolute.s}px;
  }
`;

const KitAccordionItemPanel = styled(AccordionItemPanel)`
  padding: 0 ${spacing.absolute.s}px ${spacing.absolute.s}px ${spacing.absolute.s}px;
  @media all and (min-width: ${breakpoints.xs}px) {
    padding: 0 ${spacing.absolute.m}px ${spacing.absolute.m}px ${spacing.absolute.m}px;
  }
`;

export {
  KitAccordion,
  KitAccordionItem,
  KitAccordionItemHeading,
  KitAccordionItemButton,
  KitAccordionItemPanel,
};
